import { toStringDate } from '@src/main/shared/utils/dateUtils';

export interface CreateMessageRequest {
  subject: string;
  recipients: RecipientCreateRequest[];
  message: string;
  messageHtml: string;
  attachment?: string;
  file?: File;
  respondedFrom?: string;
  initDate?: Date;
  endDate?: Date;
}

export interface RecipientCreateRequest {
  recipient: string;
  recipientName?: string;
}

export const toFormData = (data: CreateMessageRequest): FormData => {
  const formData = new FormData();

  formData.append('subject', data.subject);
  formData.append('message', data.message);
  formData.append('messageHtml', data.messageHtml);

  if (data.attachment) formData.append('attachment', data.attachment);
  if (data.file) formData.append('file', data.file);
  if (data.recipients?.length) {
    data.recipients.forEach((recipient, index) => {
      formData.append(`recipients[${index}].recipient`, recipient.recipient);
      if (recipient.recipientName) {
        formData.append(`recipients[${index}].recipientName`, recipient.recipientName);
      }
    });
  }
  if (data.respondedFrom) {
    formData.append('respondedFrom', data.respondedFrom);
  }
  if (data.initDate) {
    formData.append('startDate', toStringDate(data.initDate));
  }
  if (data.endDate) {
    formData.append('endDate', toStringDate(data.endDate));
  }

  return formData;
};
